import { useEffect, useRef, useState } from 'react';

export default function useTimer(startTime: number): {
  days: string;
  hours: string;
  seconds: string;
  minutes: string;
  count: number;
} {
  const [count, setCount] = useState<number>(startTime);
  const intervalRef = useRef<any>();

  const days = Math.floor(count / (1000 * 60 * 60 * 24));
  const hours = Math.floor((count % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((count % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((count % (1000 * 60)) / 1000);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCount((t) => t - 1000);
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, []);

  // Add a listener to `timeLeft`
  useEffect(() => {
    if (count <= 0) {
      clearInterval(intervalRef.current);
    }
  }, [count]);

  function addZeros(n: number) {
    return n < 10 ? `0${n}` : `${n}`;
  }

  return {
    days: addZeros(days),
    hours: addZeros(hours),
    seconds: addZeros(seconds),
    minutes: addZeros(minutes),
    count: Math.floor(count / 1000),
  };
}
